export default import.meta.ROLLUP_FILE_URL_0zgiefj_e6cpWrePeXoc8A